var map = {
	"./A/index.js": 54,
	"./footer/index.js": 56,
	"./header/index.js": 58,
	"./index.js": 32,
	"./map/index.js": 60,
	"./nybanner/index.js": 62,
	"./pages/index.js": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;